function BluhomeCommandStatus(aId, aDeviceId) {
	"use strict";

	this.__type = 'BluhomeCommand:www.veritracks.com';
	this.BluHomeInitiateStatus = "";
	this.Command = null;
	this.UpdateDateUTC = null; 
	this.EnrolleeID = aId
	this.ID = aDeviceId
}
if (typeof exports !== 'undefined') {
    module.exports = BluhomeCommandStatus;
}